// src/components/PrivateRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { adminRoutes, allAdminroutes } from "../../../routes/AdminRoutes";
import { allUserroutes } from "../../../routes/UserRoutes";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("access_token_admin");

  const currentPath = window.location.pathname;



  const ukWebsiteUrl = process.env.REACT_APP_UK_WEBSITE_URL;
  const userLoginUrl = `${ukWebsiteUrl}/login_email`;

  // check if route contains "user"
  const isUserRoute = currentPath.includes("/user");

  const redirectToLogin = () => {
    window.location.href = userLoginUrl;
    return null;
  };

  if (!token) {

    return isUserRoute ? redirectToLogin() : <Navigate to="/admin-login" replace />;
  }

  try {

    const decoded = jwtDecode(token);
    const isExpired = decoded.exp < Date.now() / 1000;

    if (isExpired) {
      localStorage.clear();
      return isUserRoute ? redirectToLogin() : <Navigate to="/admin-login" replace />;
    }
  } catch (error) {
    console.error("Invalid token");
    localStorage.clear();
    return isUserRoute ? redirectToLogin() : <Navigate to="/admin-login" replace />;
  }

  // ✅ If token exists and user tries to open login page → redirect to dashboard
  // if (token && (currentPath === "/admin-login" || currentPath === "/")) {

  //   return <Navigate to="/dashboard" replace />;
  // }

  const userType = localStorage.getItem("user_type"); // "admin" or "user"




  // Take the first segment of the path
  const segments = currentPath.split("/").filter(Boolean); // remove empty strings
  const currentSegment = segments[0] || ""; // first meaningful segment


  // Build admin route keys (static parts before params)
  const adminUrls = [
    ...allAdminroutes.map(r => r.url.split("/:")[0]),
    ...adminRoutes.map(r => r.url.split("/:")[0]),
  ];


  // Check if current segment is in adminUrls
  // const isAdminRoute = adminUrls.includes(currentSegment);
  // check: is current URL actually an admin route?
  const isAdminRoute = adminUrls.includes(currentSegment);

  const userUrls = allUserroutes.map(r => r.url.split("/")[0]);
  const isUserRouteDef = userUrls.includes(currentSegment);

  if (userType === "user" && isAdminRoute && !isUserRouteDef) {
    return <Navigate to="/profile" replace />;
  }

  // const UserRouted = currentPath.includes("/profile");
  // if (userType !== "user" && UserRouted) {
  //   return <Navigate to="/organization" replace />;
  // }

  return <Outlet />;
};

export default PrivateRoute;







